import { Pipe, PipeTransform } from '@angular/core';
import { toTitleCase } from '@cs/core/utils/string.utils';

@Pipe({standalone: false, name: 'titleCase'})
export class TitleCasePipe implements PipeTransform {
  transform(value: string): string {
    return toTitleCase(value);
  }
}
